import React from "react";
import Hero from "../../components/hero/Hero";
import FindMemorial from "../../components/findmemorial/FindMemorial";
import Testimonials from "../../components/testimonials/Testimonial";
import Share from "../../components/sharetestimonial/Share";
import HowToUse from "../../components/howtouse/HowToUse";
import Seo from "../../../utils/seo/Seo";
import { DEFAULT_SEO } from "../../../utils/seo/siteConfig";
import { SITE_URL } from "../../../utils/seo/siteConfig";
import HomeSeoSections from "../../components/home/HomeSeoSections";

function Homepage() {
  const homeJsonLd = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "WillAlwaysLoveU",
    url: SITE_URL,
    description: DEFAULT_SEO.description,
    potentialAction: {
      "@type": "SearchAction",
      target: `${SITE_URL}/?q={search_term_string}`,
      "query-input": "required name=search_term_string",
    },
  };

  return (
    <>
      <Seo title={DEFAULT_SEO.title} description={DEFAULT_SEO.description} path="/" jsonLd={homeJsonLd} />
      <Hero />
      <FindMemorial />
      {/* <Features /> */}
      <Testimonials />
      <Share />
      <HowToUse />
      <HomeSeoSections />
    </>
  );
}

export default Homepage;
